/* eslint-disable react/jsx-no-useless-fragment */
import React, { useEffect, useState } from 'react';

let ShakaVideoPlayer;
function ShakaPlayerTestimonials({ videoUrl }, playerRef) {
  const [isBrowser, setIsBrowser] = useState(false);
  useEffect(() => {
    // eslint-disable-next-line global-require
    ShakaVideoPlayer = require('shaka-player-react');
    setIsBrowser(true);
  }, []);
  return (
    <>
      {isBrowser ? (
        <>
          <ShakaVideoPlayer
            // autoplay
            height="100%"
            width="100%"
            src={videoUrl}
            ref={playerRef}
          />
        </>
      ) : null}
    </>
  );
}

export default React.forwardRef(ShakaPlayerTestimonials);
